import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from '../../../dto/user';
import {FormControl} from '@angular/forms';
import {ReplaySubject, Subject} from 'rxjs';
import {UserTimeLineByDate} from '../../../dto/user-location/user-timeline-by-date';
import {Point} from '../../../dto/user-location/point';
import {Market} from '../../../dto/market';
import {MarketLevel} from '../../../dto/market-level';
import {DaterangepickerDirective, LocaleConfig} from 'ngx-daterangepicker-material';
import * as L from 'leaflet';
import 'leaflet.gridlayer.googlemutant';
// import {base_urls} from '../../../config/base_urls';
import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import swal from 'sweetalert2';
import {BaseService} from '../../../services/base.service';
import {ActivatedRoute, Route} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {DatePipe, Location} from '@angular/common';
import {MatSelectChange} from '@angular/material';
import {MarketService} from '../../../services/market.service';
import {GeneralBroadcastService} from '../../../services/general-broadcast.service';
import {base_urls} from '../../../config/base-url';
import {TitleBroadcastService} from '../../../services/title-broadcast.service';


@Component({
    selector: 'app-user-timeline-by-date',
    templateUrl: './user-timeline-by-date.component.html',
    styleUrls: ['./user-timeline-by-date.component.scss']
})
export class UserTimelineByDateComponent implements OnInit {

    lat = 23.8383283;
    lng = 90.3759853;
    datePipe = new DatePipe('en-US');
    loggedUser: User;
    userList: User[] = [];
    filteredUserList: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);
    userFilter: FormControl = new FormControl();
    timelineList: UserTimeLineByDate[] = [];
    filteredTimelineList: UserTimeLineByDate[] = [];
    listDataSource: Point[] = [];
    loadingData = false;
    markets = [];
    selectedMarket: Market[] = [];
    marketLevels: MarketLevel[] = [];
    displayedColumns = ['SN', 'From', 'To', 'Address', 'Duration', 'Distance'];
    lineColors: string[] = ['mediumseagreen', 'deepskyblue', 'gray', 'navy', 'yellow', 'orange', 'purple', 'cyan', 'magenta', 'lime'];
    imeiList: any[] = [];
    selectedImei: string;
    isCalenderOpen = false;
    tabList = ['Map', 'Timeline'];
    selectedRange: any = {startDate: null};
    calendarLocale: LocaleConfig;
    userRank: number;
    marketFilterForm: FormControl = new FormControl();
    filteredMarketList = [];
    marketIndex = 0;
    map: L.Map;
    polyLineLayer: L.LayerGroup = L.layerGroup();
    markerLayerGroup: L.LayerGroup = L.layerGroup();
    selectedTab = 'Map';
    customStyle = [
        {
            'featureType': 'landscape',
            elementType: 'geometry',
            'stylers': [
                {'hue': '#37cb37'},
                {'saturation': -20},
                {'lightness': -8}
            ]
        }
    ];

    userId: number;
    userCode: string;
    filters = {
        'userId': null,
        'date': moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        fileType: null
    };

    private _unsubscribeAll: Subject<any>;
    @ViewChild(DaterangepickerDirective, {static: true}) dateRangePicker: DaterangepickerDirective;

    constructor(private service: BaseService, private router: ActivatedRoute, private generalBroadcastService: GeneralBroadcastService,
                private auth: AuthService, private marketService: MarketService, private location: Location, private titleBroadcastService: TitleBroadcastService) {

        this._unsubscribeAll = new Subject();
        this.loggedUser = this.auth.user;
        this.marketLevels = marketService.marketLevels;
        this.marketLevels.forEach(pMarketLevel => {
            this.markets[pMarketLevel.Rank] = [];
            this.selectedMarket[pMarketLevel.Rank] = null;
            const filteredMarket: ReplaySubject<Market[]> = new ReplaySubject<Market[]>(1);
            this.filteredMarketList.push(filteredMarket);
        });
        this.userRank = marketService.userRank;
        this.selectedMarket = this.marketService.prepareUserMarket();
        this.calendarLocale = {
            customRangeLabel: 'Pick a date...',
            applyLabel: 'Apply',
            cancelLabel: 'Clear',
            format: 'DD-MMM-YYYY',
            daysOfWeek: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            firstDay: 1
        };
        this.selectedRange.startDate = moment().subtract(0, 'days').startOf('day');

        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('User Timeline By Date');
    }

    ngOnInit(): void {
        this.map = L.map('map').setView([23.8383283, 90.3759853], 7);
        L.gridLayer.googleMutant({
            type: 'roadmap',
            styles: this.customStyle
        }).addTo(this.map);

        this.userFilter.valueChanges.pipe(debounceTime(500), takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.userList) {
                return;
            }

            const search = this.userFilter.value;
            if (!search) {
                this.filteredUserList.next(this.userList.slice());
                return;
            }

            this._getUserList(search);
            this.filteredUserList.next(this.userList.filter(user => user.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 || user.Code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });

        this.router.queryParams.subscribe(params => {
            if (params.userCode) {
                this._getUserList(params.userCode);
                this.userCode = params.userCode;
            } else {
                this._getUserList();
            }
            if (params.userId) {
                this.filters.userId = Number(params.userId);
                this.userId = Number(params.userId);
            }
            if (params.date) {
                this.filters.date = params.date;
                this.selectedRange.startDate = moment(params.date);
            }
            if (params.date) {
                this.getLocationList();
            }
        });

        // this.loadInitialMarkets();
        this.marketFilterForm.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
            if (!this.markets[this.marketIndex]) {
                return;
            }

            const search = this.marketFilterForm.value;
            if (!search) {
                this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
                return;
            }
            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].filter(product => product.name.toLowerCase().indexOf(search.toLowerCase()) > -1 || product.code.toLowerCase().indexOf(search.toLowerCase()) > -1));
        });
    }

    dateChangeListener(): void {
        this.filters.date = this.datePipe.transform(this.selectedRange.startDate, 'yyyy-MM-dd');
        this.isCalenderOpen = false;
    }

    compareUsers(pUser1: number, pUser2: number): boolean {
        return pUser1 && pUser2 && pUser1 == pUser2;
    }

    loadInitialMarkets(): void {
        this.marketService.getInitialMarketList().subscribe(responses => {
            responses.forEach((pResponse, index) => {
                const pMarketLevel = this.marketLevels[index];
                this.markets[pMarketLevel.Rank] = pResponse;
                this.filteredMarketList[index].next(this.markets[pMarketLevel.Rank].slice());
            });
        });
    }

    marketFilterChangeListener(pEvent: MatSelectChange): void {
        this.marketService.marketChangeListener(pEvent, this.marketIndex, this.selectedMarket).subscribe(pResponse => {
            this.selectedMarket = pResponse;
        });
    }

    saveNavigation(): void {
        const hasQueryParams = this.userCode || this.userId;
        const convertedQueryParams = `?userCode=${this.userCode}&userId=${this.userId}`;
        const baseUrl = this.location.path().split('?')[0];
        this.location.replaceState(`${baseUrl}${hasQueryParams ? convertedQueryParams : ''}`);
    }

    getSelectedLevelMarkets(marketLevel: MarketLevel): void {
        this.marketIndex = marketLevel.Rank;
        this.marketService.getSelectedLevelMarkets(marketLevel, this.selectedMarket).subscribe(pResponse => {
            this.markets[this.marketIndex] = pResponse;
            this.filteredMarketList[this.marketIndex - 1].next(this.markets[this.marketIndex].slice());
        });
    }

    clearMapData(): void {
        this.userId = null;
        this.userCode = null;
        this.filteredTimelineList = [];
        this.timelineList = [];
        this.imeiList = [];
        this.polyLineLayer.clearLayers();
        this.markerLayerGroup.clearLayers();
        this.filters.userId = null;
        this.saveNavigation();
    }

    resetParameters(): void {
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.selectedMarket[i] = null;
            }
        }
    }

    compareMarkets(pMarket1: Market, pMarket2: Market): boolean {
        return pMarket1 && pMarket2 && pMarket1.Id === pMarket2.Id;
    }

    _getUserList(search?: string): void {
        let marketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                marketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }

        this.service.getUserList({
            ResponseSize: 'MINIFY',
            MarketIdList: marketIdList,
            SearchKey: search,
            PageNumber: 0,
            RecordsPerPage: 50
        }).subscribe(userList => {
            this.userList = userList;
            this.filteredUserList.next(this.userList.slice());
        });
    }

    openPicker(): void {
        this.isCalenderOpen = !this.isCalenderOpen;
        if (this.isCalenderOpen) {
            this.dateRangePicker.open();
        } else {
            this.dateRangePicker.hide();
        }
    }

    interpolatePoints(start: [number, number], end: [number, number]): [number, number][] {
        const points: [number, number][] = [];
        const totalPoints = Math.ceil((this.calculateDistance(start, end) / 40) * 0.5);
        for (let i = 1; i <= totalPoints; i++) {
            const lat = start[0] + ((end[0] - start[0]) / (totalPoints + 1)) * i;
            const long = start[1] + ((end[1] - start[1]) / (totalPoints + 1)) * i;
            points.push([lat, long]);
        }

        return points;
    }

    calculateAngle(point1: [number, number], point2: [number, number]): number {
        const lat1 = point1[0];
        const long1 = point1[1];
        const lat2 = point2[0];
        const long2 = point2[1];

        const angleRad = Math.atan2(long2 - long1, lat2 - lat1);
        const angleDeg = angleRad * (180 / Math.PI);
        return angleDeg - 90;
    }

    calculateDistance(point1: [number, number], point2: [number, number]): number {
        const [lat1, lon1] = point1;
        const [lat2, lon2] = point2;

        const toRadians = (degrees: number) => degrees * (Math.PI / 180);

        const R = 6371;
        const dLat = toRadians(lat2 - lat1);
        const dLon = toRadians(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c * 100;
    }

    getLocationList(): void {
        if (!this.filters.userId) {
            swal('Error!', 'Please select a user', 'error');
            return;
        }

        this.loadingData = true;
        this.service.getUserTimelineByDate(this.filters, base_urls.p_base).subscribe(locationList => {
            this.loadingData = false;
            if (locationList.length > 0) {
                this.timelineList = locationList;
                this.filteredTimelineList = locationList;
                this.lat = locationList[0].points[0].latitude;
                this.lng = locationList[0].points[0].longitude;
                this.listDataSource = locationList.map(pItem => pItem.points).reduce((acc, points) => acc.concat(points), []);
                this.imeiList = locationList.map(pItem => ({Imei: pItem.imei, Device: pItem.deviceModel}));
            } else {
                this.timelineList = [];
                this.filteredTimelineList = [];
                this.imeiList = [];
            }
            this.prepareMapData();
        }, error => {
            this.loadingData = false;
        });
    }

    imeiChangeListener(): void {
        if (this.selectedImei) {
            this.filteredTimelineList = this.timelineList.filter(pItem => pItem.imei == this.selectedImei);
        } else {
            this.filteredTimelineList = this.timelineList;
        }
        this.prepareMapData();
        this.listDataSource = this.filteredTimelineList.map(pItem => pItem.points).reduce((acc, points) => acc.concat(points), []);
    }

    prepareMapData(): void {
        let timeLineInfo = [];
        let coOrdsList = [];
        this.polyLineLayer.clearLayers();
        this.markerLayerGroup.clearLayers();
        this.filteredTimelineList.forEach((pTimeLine, pTimeLineIndex) => {
            timeLineInfo = pTimeLine.points
                .filter(pData => pData.latitude >= 0 && pData.longitude >= 0)
                .map((
                {
                    latitude: pLatitude,
                    longitude: pLongitude,
                    fromTime: pFromTime,
                    tillTime: pTillTime,
                    address: pAddress,
                    durationStr: pDurationStr,
                    duration: pDuration,
                    distance: pDistance,
                    distanceStr: pDistanceStr,
                    speedFromPreviousPointStr: pSpeedFromPreviousPointStr,
                }) => ({
                fromTime: pFromTime,
                tillTime: pTillTime,
                address: pAddress,
                durationStr: pDurationStr,
                duration: pDuration,
                distance: pDistance,
                distanceStr: pDistanceStr,
                speedFromPreviousPointStr: pSpeedFromPreviousPointStr,
                coOrds: [pLatitude, pLongitude],
            }));
            const currentCoOrdsList = timeLineInfo.map(pItem => pItem.coOrds);
            coOrdsList = [...coOrdsList, ...currentCoOrdsList];
            if (coOrdsList.length > 0) {
                const bounds = L.latLngBounds(coOrdsList);
                this.map.fitBounds(bounds, {padding: [50, 50]});
            } else {
                this.map.setView([23.8383283, 90.3759853], 7);
            }
            const currentPolyline = L.polyline(currentCoOrdsList, {
                color: this.lineColors[this.selectedImei ? this.imeiList.findIndex(pImei => pImei.Imei == this.selectedImei) : pTimeLineIndex],
                weight: 15,
                opacity: 1,
                lineCap: 'round'
            });
            this.polyLineLayer.addLayer(currentPolyline);
            let customIcon = null;

            timeLineInfo.forEach((pItem, pIndex) => {
                console.log(pItem);
                const backgroundColor = pItem.duration > 0 ? 'red' : 'white';
                const textColor = pItem.duration > 0 ? 'white' : 'black';
                const borderColor = pItem.duration > 0 ? 'white' : 'black';
                const height = pIndex < 99 ? '20px' : '25px';
                const width = pIndex < 99 ? '20px' : '25px';
                if (pIndex != 0 && pIndex < timeLineInfo.length - 1) {
                    customIcon = L.divIcon({
                        html: `<div style="display: flex; align-items: center; justify-content: center; height: ${height}; width: ${width}; font-size: 12px; 
                                        background: ${backgroundColor}; 
                                        color: ${textColor}; 
                                        border: 1px solid ${borderColor}; 
                                        border-radius: 50%">${pIndex + 1}</div>`,
                        iconSize: pIndex < 99 ? [20, 20] : [25, 25],
                        iconAnchor: pIndex < 99 ? [10, 20] : [12.5, 25],
                        className: ''
                    });
                } else if (pIndex == 0) {
                    customIcon = L.icon({
                        iconUrl: '/assets/icons/markers/tracking_start.png',
                        iconSize: [30, 30],
                        iconAnchor: [15, 30]
                    });

                } else {
                    customIcon = L.icon({
                        iconUrl: '/assets/icons/markers/tracking_current.png',
                        iconSize: [30, 30],
                        iconAnchor: [15, 30]
                    });
                }

                const marker = L.marker(pItem.coOrds, {icon: customIcon})
                    .bindPopup(
                        `
                        <div style="display: flex; flex-direction: column; gap: 10px">
                            <div style="color: #737373; font-weight: bold; font-size: 15px">${pIndex + 1}.</div>
                            <div style="display: flex; flex-direction: row; align-items: center; justify-content: flex-start; gap: 10px">
                                <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; flex-direction: row; gap: 2px; margin-left: 2px">
                                    <img style="height: 16px; width: 16px;" src="/assets/icons/location-icons/clock-2.svg">
                                    <div style="color: #737373; font-weight: bold">${this.datePipe.transform(pItem.fromTime, 'hh:mm a')} to ${this.datePipe.transform(pItem.tillTime, 'hh:mm a')} </div>
                                </div>
                                <div style="font-size: 12px; font-family: Muli; display: flex; flex-direction: row; align-items: center; gap: 2px">
                                    <div style="height: 5px; width: 5px; border-radius: 50%; background-color: #737373"></div>
                                    <div style="color: #737373; font-weight: bold">${pItem.durationStr ? pItem.durationStr : 'Travelling'}</div>
                                </div>   
                             </div>
                            <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; justify-content: flex-start; flex-direction: row; gap: 2px;">
                                <img style="height: 20px; width: 20px;" src="/assets/icons/location-icons/gauge.svg">
                                <div style="color: #737373; font-weight: bold">${pItem.speedFromPreviousPointStr.length > 0 ? pItem.speedFromPreviousPointStr : '0 meter/hour'}</div>
                            </div>
                            <div style="font-size: 12px; font-family: Muli; display: flex; align-items: center; justify-content: flex-start; flex-direction: row; gap: 2px">
                                <img style="height: 20px; width: 20px;" src="/assets/icons/location-icons/map-pin.svg">
                                <div style="color: #737373; font-weight: bold">${pItem.address}</div>
                            </div>
                        </div>
                            `, {minWidth: 400, maxWidth: 800}
                    );
                this.markerLayerGroup.addLayer(marker);
            });
        });

        for (let i = 0; i < coOrdsList.length - 1; i++) {
            const startPoint = coOrdsList[i];
            const endPoint = coOrdsList[i + 1];
            const intermediatePoints = this.interpolatePoints(startPoint, endPoint);

            intermediatePoints.forEach((point, index) => {
                const angle = this.calculateAngle(startPoint, point);

                const icon = L.divIcon({
                    html: `<div style="transform: rotate(${angle}deg); margin: 0 5px">
                    <img src="/assets/icons/location-icons/arrow.svg" style="width: 10px; height: 10px;">
                 </div>`,
                    className: 'custom-icon',
                    iconSize: [10, 10]
                });

                const marker = L.marker(point, {icon: icon});
                this.markerLayerGroup.addLayer(marker);
            });
        }
        this.map.addLayer(this.polyLineLayer);
        this.map.addLayer(this.markerLayerGroup);
    }

    tabChangeListener(pTab: string): void {
        this.selectedTab = pTab;
        const map = document.getElementById('mapContainer');
        if (pTab == 'Timeline') {
            map.style.display = 'none';
        } else {
            map.style.display = 'block';
        }
    }

}
